import React, { useMemo } from "react"
import { Link } from "react-router-dom"
import styles from "./Sidebar.module.css"
import { MenuGroup } from "./MenuGroup"
import { useDispatch, useSelector } from "react-redux"
import { Avatar, Button } from "antd"
import { colors } from "themes/variables"
import classNames from "classnames"
import { Icon } from "ui/Icon"
import { setProHomeMenuClose } from "store/pro-home-menu"
import { signOut } from "store/auth"
import { useTranslation } from "react-i18next"
import { proMenuList, proMenuKeys } from "./proMenuList"
import { routes } from "router"
import { usePermissions } from "hooks/usePermissions"
import { MODULES, ACTIONS } from "utils/permissions"

export const Sidebar = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { open } = useSelector((state) => state.proHomeMenu)
  const { avatar, guide, role, first_name, last_name, email } = useSelector((state) => state.user)
  const { hasModuleAccess, hasFullAccess, hasPermission } = usePermissions()

  const closeMenu = () => {
    dispatch(setProHomeMenuClose())
  }

  const handleLogoutBtnClick = () => {
    dispatch(signOut())
  }

  const filteredMenuList = useMemo(() => {
    return proMenuList?.map((menuGroup) => {
      const filteredItems = menuGroup?.items?.filter((item) => {

        if (item.id === proMenuKeys.dashboard) {
          return hasPermission(MODULES.ACCOUNTING, ACTIONS.FULL_ACCESS)
        }

        if (!item.requiredModule) {
          return true
        }

        if (hasFullAccess()) {
          return true
        }

        return hasModuleAccess(item.requiredModule)
      })

      return {
        ...menuGroup,
        items: filteredItems
      }
    }).filter((menuGroup) => menuGroup.items.length > 0)
  }, [hasModuleAccess, hasFullAccess, hasPermission, email])

  return (
    <div className={classNames(styles.sidebar, open ? styles.open : styles.close)}>
      <div className={styles.header}>
        <Link onClick={closeMenu} className={styles.headerTitle} to={routes.proSettingsProfileInformation()}>
          <Avatar
            src={avatar?.includes("localhost") ? avatar.replace("https://", "http://") : avatar}
            style={{
              border: `1.5px solid ${colors.lines}`,
              flexShrink: 0
            }}
            className={styles.avatar}
          />
          <div className={styles.guideName}>
            {role === "guide_user" ? guide?.display_name : `${first_name} ${last_name}`}
          </div>
        </Link>
        <div onClick={closeMenu} className={styles.closeIconWrapper}>
          <Icon width={32} height={32} type="feather" name="X" color="currentColor" />
        </div>
      </div>
      <div className={styles.sidebarBody}>
        {filteredMenuList.map((menuItem) => (
          <MenuGroup key={menuItem.id} menuItem={menuItem} />
        ))}

        <Button className={styles.logoutButton} color="primary" variant="outlined" size="large" onClick={handleLogoutBtnClick}>
          {t("header.log_out")}
        </Button>
      </div>
    </div>
  )
}
